import React, { useRef } from "react";

import { useDetermineMobile } from "../../hooks/useDetermineMobile";
import type { ChartData, ChartOptions } from "chart.js";

import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const options: ChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
    title: {
      display: true,
      text: "Capacity chart",
    },
  },
};

interface BarChartProps {
  data: ChartData<"bar", (number | null)[], unknown>;
}

const BarChart: React.FC<BarChartProps> = ({ data }) => {
  const { isMobile } = useDetermineMobile();
  const ref = useRef();
  return (
    <Bar
      ref={ref}
      height={isMobile ? undefined : 50}
      data={data}
      options={options}
    />
  );
};

export default BarChart;
